import { render, staticRenderFns } from "./trade-ideas.component.vue?vue&type=template&id=fc660238&scoped=true"
import script from "./trade-ideas.component.vue?vue&type=script&lang=js"
export * from "./trade-ideas.component.vue?vue&type=script&lang=js"
import style0 from "./trade-ideas.component.vue?vue&type=style&index=0&id=fc660238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc660238",
  null
  
)

export default component.exports